import axios from 'axios';

const API_URL = '/api/customer-journey';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const customerJourneyService = {
  /**
   * Generate customer personas
   */
  async generatePersonas(numberOfPersonas, personaDescriptions) {
    try {
      const response = await axios.post(`${API_URL}/generate`, {
        number_of_personas: numberOfPersonas,
        persona_descriptions: personaDescriptions
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to generate personas'
      };
    }
  },

  /**
   * Get saved personas
   */
  async getPersonas() {
    try {
      const response = await axios.get(`${API_URL}/personas`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get personas'
      };
    }
  },

  /**
   * Save edited personas
   */
  async savePersonas(personasText, numberOfPersonas) {
    try {
      const response = await axios.post(`${API_URL}/save`, {
        personas_text: personasText,
        number_of_personas: numberOfPersonas
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to save personas'
      };
    }
  }
};

export default customerJourneyService;
